import {
	useCreateTagType,
	useDeleteTagType,
	useOrganisation,
	useUpdateTagType,
} from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";
import TaxonomyCrudEditor from "./TaxonomyCrudEditor";

/**
 * "Konsulttaggar" — CRUD over the org's `consultantTagTypes` taxonomy via the
 * dedicated tag-type endpoints. Consultant tags can carry a validity duration
 * (in HOURS — the consultant's expiry is computed automatically on assign)
 * and be used as matching requirements — hence the stronger delete warning
 * and the TAG_TYPE_IN_USE handling in the shared editor.
 */
const KonsulttaggarPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutateAsync: createTagType, isLoading: isCreating } = useCreateTagType();
	const { mutateAsync: updateTagType, isLoading: isUpdating } = useUpdateTagType();
	const { mutateAsync: deleteTagType, isLoading: isDeleting } = useDeleteTagType();

	return (
		<SettingsLeaf
			title="Konsulttaggar"
			description="Taggar som kan sättas på konsulter, användas som krav vid matchning och som filter i konsultlistan. En tagg med giltighetstid (i timmar) löper ut automatiskt och tas då bort från konsulten."
		>
			<TaxonomyCrudEditor
				items={organisation?.consultantTagTypes ?? []}
				addLabel="Lägg till tagg"
				emptyText="Inga konsulttaggar har skapats ännu."
				showValidity
				validityUnit="hours"
				showColor
				showListViewVisibility
				isSaving={isCreating || isUpdating || isDeleting}
				onCreate={({ name, validityDuration, color, showInListViews }) =>
					createTagType({ taxonomy: "consultant", name, validityDuration, color, showInListViews })
				}
				onUpdate={(key, { name, validityDuration, color, showInListViews }) =>
					updateTagType({
						taxonomy: "consultant",
						key,
						name,
						validityDuration,
						color,
						showInListViews,
					})
				}
				onDelete={(key) => deleteTagType({ taxonomy: "consultant", key })}
				deleteTitle={(item) => `Ta bort taggen "${item.name.sv}"?`}
				deleteDescription={() =>
					"Taggen tas bort från alla konsulter och från alla uppdrags krav. Det kan påverka vilka konsulter som matchar mot uppdrag. Detta går inte att ångra."
				}
			/>
		</SettingsLeaf>
	);
};

export default KonsulttaggarPage;
